module.exports = __webpack_public_path__ + "img/maki-2.d8b59ecc.png";